<template>
  <v-layout row align-center justify-space-around>
    <v-flex xs12 order-lg2>
      <v-list two-line class="scroll-y" style="max-height: 400px" v-if="dataState === 'loading' || dataState === 'ready'" :class="dataState !== 'ready' ? 'blurClass' : ''">
        <template v-for="(item, index) in sources">
          <v-list-tile
            :key="item._domain"
            avatar
            @click="goToSource(item._domain)"
          >
            <v-list-tile-content>
              <v-list-tile-title v-html="item._domain"></v-list-tile-title>
              <v-list-tile-sub-title v-html="formatDate(item._latest_date_published)"></v-list-tile-sub-title>
            </v-list-tile-content>
            <v-tooltip top>
              <v-list-tile-avatar size="40" slot="activator" @click.stop="filterByDomain(item._domain)">
                <v-icon class="btnHoverClass" style="border-radius: 100%">filter_list</v-icon>
              </v-list-tile-avatar>
              <span>Filter by domain</span>
            </v-tooltip>
          </v-list-tile>
          <v-divider v-if="sources[index+1]"></v-divider>
        </template>
      </v-list>
      <template v-if="dataState === 'loading'">
        <center class="alternateState">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </center>
      </template>
      <template v-else-if="dataState === 'noData'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
      </template>
      <template v-else-if="dataState === 'error'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
      </template>
    </v-flex>
  </v-layout>
</template>

<style scoped>
.btnHoverClass:hover{background-color: #E0E0E0}
.alternateState{
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.blurClass{
  filter: blur(5px);
  -webkit-filter: blur(5px);
}
</style>

<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import { formatDateTimeWithYear } from '@/helpers/formatters'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      sources: []
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getQuery'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setCustomFilters']),
    goToSource (source) {
      window.open('http://' + source, '_blank')
    },
    formatDate (date) {
      return formatDateTimeWithYear(date)
    },
    filterByDomain (domain) {
      this.setCustomFilters({domain: domain})
      // this.$router.push({ path: '/articles', query: this.$route.query })
    },
    getData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getNewsSources', this.getQuery({sortBy: '_latest_date_published', order: 'desc', pageSize: 30}))
      ]).then(axios.spread((r1) => {
        if (r1.data.status === 'SUCCESS') {
          this.sources = r1.data.payload
          if (r1.data.payload.length > 0) {
            this.dataState = 'ready'
          } else {
            this.dataState = 'noData'
          }
        } else {
          this.dataState = 'error'
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (!underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.getData()
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/rankings/SourcesByDate.vue